export const createContact = {
  label: null,
  phoneNumber: null,
  location: null,
}
